export const STRICTLY_NECESSARY = 'STRICTLY_NECESSARY';
export const FUNCTIONAL = 'FUNCTIONAL';
export const PERFORMANCE = 'PERFORMANCE';
export const TARGETING = 'TARGETING';
export const ADVERTISING = 'ADVERTISING';
export const SOCIAL = 'SOCIAL';
